import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Landing Page
      landing: {
        // Navigation
        features: "Features",
        demo: "Demo",
        posSystem: "POS System",
        pricing: "Pricing",
        getStarted: "Get Started",
        dashboard: "Dashboard",
        
        // Hero Section
        badge: "AI-Powered Cloud POS for Restaurants",
        heroTitle1: "Restaurant POS System",
        heroTitle2: "with AI Marketing Built In",
        heroSubtitle: "Run your restaurant on the only cloud POS that charges cards, streams to your kitchen display, and auto-generates Instagram & TikTok content — in 30+ countries. Start free forever.",
        startFree: "Start Free Now",
        goToDashboard: "Go to Dashboard",
        watchDemo: "Watch Demo",
        
        // Trust Badges
        noCredit: "No credit card",
        freePlan: "Free forever plan",
        freeImages: "5 AI images + 5 posts",
        
        // Feature Pills
        aiFeatures: "AI-Powered Features",
        aiContent: "AI Content Generation",
        aiImage: "AI Image Creation",
        videoReels: "Video & Reels",
        socialScheduling: "Social Scheduling",
        
        // Metrics
        restaurants: "Restaurants",
        postsCreated: "Posts Created",
        engagements: "Engagements",
        successRate: "Success Rate",
        
        // Features Section
        featuresTitle: "Superpowers",
        featuresSubtitle: "for Your Restaurant",
        featuresDesc: "Every tool you need to dominate social media",
        
        aiContentEngine: "AI Content Engine",
        aiContentDesc: "Generate captions, hashtags & descriptions instantly",
        multiMediaCreator: "Multi-Media Creator",
        multiMediaDesc: "Combine images & videos into viral Reels",
        dailyInsights: "Daily AI Insights",
        dailyInsightsDesc: "Fresh content ideas every single day",
        aiImageGen: "AI Image Generation",
        aiImageGenDesc: "Create food photos from text prompts (DALL-E)",
        posSystemFeat: "POS System",
        posSystemDesc: "Complete point-of-sale with order management & inventory",
        hrManagement: "HR Management",
        hrManagementDesc: "Employee management, payroll, shifts & document tracking",
        accounting: "Accounting",
        accountingDesc: "Sales tracking, expense management & financial reports",
        recipeManager: "Recipe Manager",
        recipeManagerDesc: "Discover recipes, AI generation & organize your cookbook",
        
        // Demo Section
        demoTitle: "Watch AI",
        demoSubtitle: "Create Magic",
        demoDesc: "See how our AI transforms simple food photos into viral social media content in seconds",
        
        // Success Stories
        successTitle: "Real Results,",
        successSubtitle: "Real Growth",
        
        // Pricing
        pricingBadge: "SIMPLE PRICING",
        pricingTitle: "Start Free,",
        pricingSubtitle: "Upgrade Anytime",
        pricingDesc: "Try FlavorFeed AI with 5 AI Image Generations + 5 Post Creations FREE. No credit card required. Upgrade when you're ready.",
        pricesIn: "Prices shown in",
        monthly: "Monthly",
        annual: "Annual",
        saveAnnual: "Save up to 20% with Annual Billing!",
        
        // Plans
        freePlanName: "Free",
        basicPlanName: "Basic",
        proPlanName: "Pro",
        enterprisePlanName: "Enterprise",
        
        freeBadge: "START HERE",
        basicBadge: "CONTENT CREATORS",
        proBadge: "BEST VALUE",
        enterpriseBadge: "PREMIUM",
        
        perMonth: "/month",
        perYear: "/year",
        billedAnnually: "/month billed annually",
        savePerYear: "Save",
        
        // CTA Buttons
        startFreeNow: "Start Free Now",
        tryFree: "Try It Free Now",
        comparePlans: "Compare Plans in Detail",
        seeDetailedComparison: "See Detailed Comparison",
        
        // Pricing Plan Features
        planFeatures: {
          // Free Plan
          aiImageGen: "AI Image Generations",
          aiProMakeover: "AI Pro Makeover",
          aiImageGeneration: "AI Image Generation",
          uploadCamera: "Upload & Camera",
          aiCaptionsHashtags: "AI Captions & Hashtags",
          recipeManager: "Recipe Manager Access",
          basicFeatures: "Basic Features Access",
          
          // Basic Plan
          aiPreviewCredits: "AI Preview Credits/month",
          postCreations: "Post Creations/month",
          allFreeFeatures: "All Free Features",
          socialScheduling: "Social Media Scheduling",
          emailSupport: "Email Support",
          flavorFeedOnly: "FlavorFeed Only (No POS)",
          
          // Pro Plan
          everythingBasic: "Everything in Basic",
          posStarter: "POS Starter Included",
          orderManagement: "Order Management",
          menuManagementAI: "Menu Management (AI)",
          inventoryTracking: "Inventory Tracking",
          loyaltyNetwork: "Loyalty Network (FREE 6mo)",
          crossRestaurant: "Cross-restaurant rewards",
          customerDatabase: "Customer database",
          thenMonthly: "Then $19/month",
          advancedAnalytics: "Advanced Analytics",
          prioritySupport: "Priority Support",
          
          // Enterprise Plan
          unlimited: "Unlimited",
          aiGenerations: "AI Generations",
          posts: "Posts",
          everythingPro: "Everything in Pro",
          posComplete: "POS Complete System",
          everythingStarter: "Everything from POS Starter",
          hrManagement: "HR Management",
          accountingModule: "Accounting Module",
          multiLocation: "Multi-location Support",
          loyaltyForever: "Loyalty Network (FREE Forever)",
          multiLocationLoyalty: "Multi-location loyalty",
          advancedCustomer: "Advanced customer analytics",
          dedicatedManager: "Dedicated Manager",
          advancedScheduling: "Advanced Scheduling",
          bulkRecurring: "Bulk + Recurring Posts",
          teamCollaboration: "Team Collaboration",
          whiteLabel: "White-label Options",
          customIntegrations: "Custom Integrations",
          dedicatedAccount: "Dedicated Account Manager",
          customTraining: "Custom Training",
          sla: "99.9% SLA Uptime"
        },
        
        // Restaurant Management CTA Section
        restaurantMgmtBadge: "RESTAURANT MANAGEMENT",
        restaurantMgmtTitle: "Need More Than Social Media?",
        restaurantMgmtDesc: "Get complete restaurant management with POS, Loyalty Network, HR & Accounting.",
        restaurantMgmtPOS: "POS",
        restaurantMgmtLoyalty: "Loyalty",
        restaurantMgmtHR: "HR",
        restaurantMgmtAccounting: "Accounting",
        explorePOS: "Explore POS System",
        
        // Final CTA Section - Go Viral
        readyToGo: "Ready to Go",
        viral: "Viral?",
        joinRestaurants: "Join 500+ restaurants creating content that converts",
        startCreatingNow: "Start Creating Now",
        
        // Footer
        footerCopyright: "FlavorFeed AI. Culinary Intelligence Platform.",
        
        // FAQ
        faqTitle: "Frequently Asked Questions",
        faqQ1: "What's the difference between Schedule Posts and Advanced Scheduling?",
        faqA1Part1: "Schedule Posts (Starter - $79 and up):",
        faqA1Part1Text: "Basic scheduling where you pick date/time for individual posts. Perfect for single locations posting 5-15 times per week.",
        faqA1Part2: "Advanced Scheduling (Enterprise - $249):",
        faqA1Part2Text: "Includes bulk scheduling, recurring posts, AI-powered timing, visual calendar, team collaboration, and a dedicated manager to handle your social media pages. Ideal for multi-location chains posting 20+ times per week.",
        
        faqQ2: "Which plan is right for me?",
        faqA2Text: "Choose Starter ($79) for 30 AI image generations and 15 post creations per month. Choose Growth ($99) for 50 image generations and 30 post creations, or Pro ($149) for 100 image generations and 50 post creations. Every paid plan includes the full POS.",
        
        faqQ3: "What POS plan should I choose?",
        faqA3P1: "Core POS ($29/month)",
        faqA3P1Text: "Full POS for small restaurants: order management, basic inventory, and sales reports. No AI content creation included.",
        faqA3P2: "POS Growth ($99/month)",
        faqA3P2Text: "Best for growing restaurants. Adds 50 AI image generations and 30 post creations per month, advanced inventory, and multi-branch tools.",
        faqA3P3: "POS Enterprise ($249/month)",
        faqA3P3Text: "Everything unlimited, with HR management, multi-location HQ control, and a dedicated account manager.",
        
        faqQ4: "Can I upgrade or downgrade my plan later?",
        faqA4Text: "Yes! You can upgrade or downgrade at any time. Upgrades take effect immediately. Downgrades take effect at the end of your current billing cycle. No long-term commitments required.",
        
        faqQ5: "What happens when I reach my credit limit?",
        faqA5Text: "You'll receive a notification when you're near your limit. You can either wait for credits to reset at the start of your next billing cycle or upgrade to a higher plan for more credits immediately.",
        
        faqQ6: "Is there a free plan?",
        faqA6Text: "Yes! Our Free plan ($0/month, free forever) includes the core POS for up to 50 orders/month and 30 menu items, plus 5 AI image generations and 5 post creations. No credit card required.",
        
        // Footer
        privacyPolicy: "Privacy Policy",
        termsOfService: "Terms of Service",
        contactUs: "Contact Us",
        copyright: "FlavorFeed AI. Culinary Intelligence Platform."
      },

      // Main Dashboard
      mainDashboard: {
        free: "FREE",
        ai: "AI",
        posts: "Posts",
        admin: "Admin",
        plan: "Plan",
        upgrade: "Upgrade",
        portfolio: "Portfolio",
        pos: "POS",
        help: "Help",
        logout: "Logout",
        create: "Create",
        ideas: "Ideas",
        myPosts: "Posts",
        platforms: "Platforms",
        recipes: "Recipes",
        loyalty: "Loyalty",
        subscription: "Subscription",
        settings: "Settings",
        posSupport: "POS Support",
        dailyContentIdeas: "Daily Content Ideas",
        freshMarketingIdeas: "Fresh marketing ideas updated daily",
        loadingDailyIdeas: "Loading daily ideas...",
        tips: "Tips:",
        myPostsTitle: "My Posts",
        postsCount: "posts",
        atLimit: "⚠️ At limit",
        nearLimit: "⚠️ Near limit",
        slotsRemaining: "slots remaining",
        tipArchive: "💡 Tip: Your feed shows up to 40 posts. When you create the 41st post, the oldest one will be automatically archived to keep your feed fresh!",
        headsUpArchive: "⚠️ Heads up: You're near the 40 post limit. Creating",
        morePost: "more post",
        morePosts: "more posts",
        willStartArchiving: "will start auto-archiving older content.",
        noPostsYet: "No posts yet. Create your first AI-powered content!",
        createYourFirst: "Create Your First"
      },
      
      // POS Landing Page
      posLanding: {
        // Navigation
        home: "Home",
        features: "Features",
        pricing: "Pricing",
        tryFreeTrial: "Try Free Trial",
        
        // Hero
        badge: "RESTAURANT MANAGEMENT",
        heroTitle: "Complete",
        heroTitleHighlight: "Restaurant",
        heroTitle2: "Management System",
        heroSubtitle: "From orders to accounting - manage your entire restaurant operation in one powerful platform. POS, Loyalty, HR, and more.",
        viewPricing: "View Pricing",
        
        // Stats
        ordersDaily: "Orders Processed Daily",
        uptime: "Uptime Guarantee",
        restaurants: "Restaurants",
        support: "Support",
        
        // Features
        featuresTitle: "Everything You Need to",
        featuresTitleHighlight: "Run Your Restaurant",
        featuresSubtitle: "Powerful features designed specifically for restaurant operations",
        
        orderManagement: "Order Management",
        orderManagementDesc: "Fast, intuitive order taking. Table management, kitchen display, and order tracking in real-time.",
        menuManagement: "Menu Management",
        menuManagementDesc: "AI-powered menu creation with images, descriptions, and pricing. Update in seconds.",
        inventoryTracking: "Inventory Tracking",
        inventoryTrackingDesc: "Never run out of ingredients. Auto-alerts, supplier management, and waste tracking.",
        staffManagement: "Staff Management",
        staffManagementDesc: "Schedule shifts, track attendance, and manage permissions all in one place.",
        paymentProcessing: "Payment Processing",
        paymentProcessingDesc: "Accept all payment methods. Split bills, tips, and instant payment confirmation.",
        salesReports: "Sales Reports",
        salesReportsDesc: "Real-time insights into sales, popular items, peak hours, and revenue trends.",
        
        // Loyalty
        loyaltyBadge: "LOYALTY NETWORK",
        loyaltyTitle: "Build Customer",
        loyaltyTitleHighlight: "Loyalty",
        loyaltySubtitle: "Join 1,000+ restaurants in the FlavorFeed Loyalty Network. Customers earn and redeem points across the entire network.",
        
        // Enterprise
        enterpriseBadge: "ENTERPRISE FEATURES",
        enterpriseTitle: "Scale Your",
        enterpriseTitleHighlight: "Restaurant Empire",
        enterpriseSubtitle: "Advanced features for growing restaurant chains and multi-location operations",
        
        hrManagement: "HR Management",
        hrManagementDesc: "Complete human resources system for managing your restaurant staff effectively.",
        accountingModule: "Accounting Module",
        accountingModuleDesc: "Full accounting system to track finances and maximize profitability.",
        
        // Pricing
        pricingTitle: "Which Plan Includes",
        pricingTitleHighlight: "POS?",
        pricingSubtitle: "Compare what's included in each plan",
        
        // CTA
        ctaTitle: "Ready to Transform Your",
        ctaTitleHighlight: "Restaurant?",
        ctaSubtitle: "Join 1,000+ restaurants already using FlavorFeed POS. Start your free trial today!",
        startFreeTrial: "Start Free Trial",
        needContent: "Need Content Creation Too?",
        noCreditCard: "No credit card required • Free forever plan • Cancel anytime",
        
        // Footer
        copyright: "FlavorFeed AI. Complete restaurant management solution."
      },
      
      // Navigation
      nav: {
        orders: "Orders",
        menu: "Menu",
        settings: "Settings",
        dashboard: "Dashboard",
        takeOrder: "Take Order",
        orderHistory: "Order History",
        menuManagement: "Menu Management",
        inventory: "Inventory",
        staff: "Staff",
        accounting: "Accounting",
        reports: "Reports",
        loyalty: "Loyalty",
        customers: "Customers",
        tables: "Tables",
        support: "Support",
        logout: "Logout",
        kitchenDisplay: "Kitchen Display",
        creditAccounts: "Credit Accounts",
        menuEngineering: "Menu Engineering",
        importData: "Import Data",
        receiptSettings: "Receipt Settings",
        aiChatbot: "AI Chatbot",
        systemSetup: "System Setup",
        posSettings: "POS Settings",
        printerSetup: "Printer Setup"
      },

      // Kitchen Display
      kitchen: {
        title: "Kitchen Display System",
        newOrders: "New Orders",
        preparing: "Preparing",
        ready: "Ready",
        completed: "Completed",
        autoRefresh: "Auto Refresh",
        soundNotifications: "Sound Notifications",
        fullScreen: "Full Screen",
        exitFullScreen: "Exit Full Screen",
        refresh: "Refresh",
        startPreparing: "Start Preparing",
        markReady: "Mark Ready",
        markCompleted: "Mark Completed",
        printOrder: "Print Order",
        table: "Table",
        orderNumber: "Order #",
        items: "Items",
        notes: "Notes",
        orderTime: "Order Time",
        waitingTime: "Waiting",
        noOrders: "No orders"
      },

      // Accounting
      accounting: {
        title: "Accounting Dashboard",
        overview: "Overview",
        expenses: "Expenses",
        purchaseOrders: "Purchase Orders",
        bills: "Bills & Payments",
        reports: "Reports",
        suppliers: "Suppliers",
        totalRevenue: "Total Revenue",
        totalExpenses: "Total Expenses",
        netProfit: "Net Profit",
        profitMargin: "Profit Margin",
        pendingBills: "Pending Bills",
        paidBills: "Paid Bills",
        overduePayments: "Overdue Payments",
        cashFlow: "Cash Flow",
        income: "Income",
        expense: "Expense",
        balance: "Balance",
        addExpense: "Add Expense",
        addPO: "Add Purchase Order",
        addBill: "Add Bill",
        addSupplier: "Add Supplier",
        category: "Category",
        amount: "Amount",
        date: "Date",
        description: "Description",
        status: "Status",
        paid: "Paid",
        pending: "Pending",
        overdue: "Overdue",
        dueDate: "Due Date",
        paymentMethod: "Payment Method",
        supplier: "Supplier",
        total: "Total",
        subtotal: "Subtotal",
        tax: "Tax",
        discount: "Discount",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        view: "View",
        markAsPaid: "Mark as Paid",
        download: "Download",
        export: "Export",
        filter: "Filter",
        search: "Search",
        today: "Today",
        thisWeek: "This Week",
        thisMonth: "This Month",
        thisYear: "This Year",
        custom: "Custom",
        from: "From",
        to: "To",
        apply: "Apply",
        reset: "Reset"
      },
      
      // Order Taking
      order: {
        selectItems: "Select Items",
        all: "All",
        orderType: "Order Type",
        dineIn: "Dine-in",
        takeaway: "Takeaway",
        delivery: "Delivery",
        tableNumber: "Table Number",
        cart: "Cart",
        cartEmpty: "Cart is empty",
        subtotal: "Subtotal",
        tax: "Tax",
        vat: "VAT",
        total: "Total",
        placeOrder: "Place Order",
        processing: "Processing...",
        todayOrders: "Today's Orders",
        todayRevenue: "Today's Revenue",
        activeOrders: "Active Orders",
        startPreparing: "Start Preparing",
        markReady: "Mark Ready",
        complete: "Complete"
      },
      
      // Menu Management
      menuMgmt: {
        title: "POS Menu Management",
        subtitle: "Manage your restaurant menu items",
        addMenuItem: "Add Menu Item",
        allItems: "All Items",
        noItems: "No menu items yet",
        getStarted: "Click \"Add Menu Item\" to get started!",
        available: "Available",
        unavailable: "Unavailable",
        itemName: "Item Name",
        category: "Category",
        price: "Price",
        cost: "Cost",
        description: "Description",
        prepTime: "Preparation Time",
        prepTimeMin: "Preparation Time (min)",
        calories: "Calories",
        caloriesKcal: "Calories (kcal)",
        customizations: "Customizations",
        cancel: "Cancel",
        addItem: "Add Item",
        required: "*",
        deleteConfirm: "Are you sure you want to delete this item?",
        deleteSuccess: "Item deleted successfully!",
        addSuccess: "Menu item added successfully!",
        selectCategory: "Select a category",
        addNewCategory: "Add New Category",
        enterNewCategory: "Enter new category name"
      },
      
      // Settings
      settings: {
        title: "Restaurant Settings",
        subtitle: "Configure your region, tax, and business information",
        regionTax: "Region & Tax",
        country: "Country / Region",
        selectCountry: "Select a country",
        taxRate: "Tax Rate",
        currency: "Currency",
        businessInfo: "Business Information",
        businessName: "Business Name",
        vatNumber: "VAT / Tax Registration Number",
        vatRecommended: "(Recommended)",
        vatWarning: "Recommended for ZATCA compliant invoices. Must be 15 digits, start and end with 3.",
        businessAddress: "Business Address",
        phone: "Phone Number",
        email: "Email",
        language: "Language",
        selectLanguage: "Select language",
        saveSettings: "Save Settings",
        saving: "Saving...",
        reset: "Reset",
        settingsSaved: "Settings Saved Successfully!",
        changesApplied: "Your changes have been applied."
      },
      
      // Sidebar Navigation
      sidebar: {
        analyticsReports: "Analytics & Reports",
        dashboardOverview: "Dashboard Overview",
        aiAnalytics: "AI Analytics",
        reports: "Reports",
        menuInventory: "Menu & Inventory",
        menuManagement: "Menu Management",
        inventory: "Inventory",
        recipeManagement: "Recipe Management",
        importData: "Import Data",
        procurementAccounts: "Procurement & Accounts",
        accounting: "Accounting",
        creditAccounts: "Credit Accounts",
        cashDrawer: "Cash Drawer",
        enterprise: "Enterprise",
        multiBranch: "Multi-Branch",
        loyaltyProgram: "Loyalty Program",
        staffHR: "Staff & HR",
        employeeManagement: "Employee Management",
        hrDashboard: "HR Dashboard",
        systemSetup: "System Setup",
        posSettings: "POS Settings",
        openPOSTerminal: "Open POS Terminal",
        adminDashboard: "Admin Dashboard"
      },

      // POS Terminal
      posTerminal: {
        takeOrder: "Take Order",
        kitchenDisplay: "Kitchen Display",
        tables: "Tables",
        orderHistory: "Order History",
        cashDrawer: "Cash Drawer"
      },
      
      // Common
      common: {
        save: "Save",
        close: "Close",
        edit: "Edit",
        delete: "Delete",
        search: "Search",
        loading: "Loading...",
        min: "min",
        new: "NEW"
      },
      
      // Staff
      staff: {
        title: "Staff Management",
        subtitle: "Manage team and permissions"
      },
      
      // Reports
      reports: {
        title: "Reports",
        subtitle: "Analytics and insights"
      },
      
      // Tables
      tables: {
        title: "Tables",
        subtitle: "Table management"
      },
      
      // Customers
      customers: {
        title: "Customers",
        subtitle: "Customer management",
        customerGroups: "Customer Groups"
      },
      
      // Loyalty
      loyalty: {
        title: "Loyalty Network",
        subtitle: "Loyalty program"
      },
      
      // Categories
      categories: {
        "Pizza": "Pizza",
        "Burgers": "Burgers",
        "Indian": "Indian",
        "Salads": "Salads",
        "Thai": "Thai",
        "Italian": "Italian",
        "Drinks": "Drinks"
      },

      // Cash Drawer Management
      cashDrawer: {
        title: "Cash Drawer Management",
        manageCashFlow: "Manage cash flow and shift operations",
        noActiveSession: "No Active Cash Drawer Session",
        openShiftPrompt: "Start a new shift to begin tracking cash flow",
        openShift: "Open Shift",
        closeShift: "Close Shift",
        shiftOpen: "Shift Open",
        cashier: "Cashier",
        cashierName: "Cashier Name",
        shiftStart: "Shift Started",
        shiftDuration: "Duration",
        minutesAgo: "minutes ago",
        openingBalance: "Opening Balance",
        closingBalance: "Closing Balance",
        expectedCash: "Expected Cash in Drawer",
        expectedCashDesc: "Based on opening balance + cash sales + cash in - cash out",
        actualCashCount: "Actual Cash Count",
        totalOrders: "Total Orders",
        cashSales: "Cash Sales",
        cardSales: "Card Sales",
        cashIn: "Cash In",
        cashOut: "Cash Out",
        addCash: "Add Cash",
        removeCash: "Remove Cash",
        amount: "Amount",
        reason: "Reason",
        notes: "Notes",
        closingNotes: "Closing Notes",
        startShift: "Start Shift",
        autoCloseHours: "Auto-Close After",
        autoCloseDesc: "Shift will automatically close after this many hours",
        lastClosing: "Suggested from last shift",
        variance: "Variance",
        varianceWarning: "Cash count doesn't match expected amount. Manager override required.",
        overrideAndClose: "Override & Close Shift",
        countDenominations: "Count by Denominations",
        hideDenominations: "Hide Denomination Counter",
        denominationCount: "Count Cash by Denomination",
        recentTransactions: "Recent Cash Transactions"
      },

      // Recipe Management
      recipes: {
        title: "Recipe Management",
        subtitle: "Create batch recipes with automatic inventory control",
        createRecipe: "Create Recipe",
        editRecipe: "Edit Recipe",
        deleteRecipe: "Delete Recipe",
        duplicateRecipe: "Duplicate Recipe",
        recipeName: "Recipe Name",
        recipeType: "Recipe Type",
        batchProduction: "Batch Production",
        singleServing: "Single Serving",
        description: "Description",
        batchDetails: "Batch & Portion Details",
        batchSize: "Batch Size",
        portionSize: "Portion Size",
        totalPortions: "Total Portions",
        ingredients: "Ingredients",
        addIngredient: "Add Ingredient",
        inventoryItem: "Inventory Item",
        quantity: "Quantity",
        cost: "Cost",
        costSummary: "Cost Summary",
        totalBatchCost: "Total Batch Cost",
        costPerPortion: "Cost per Portion",
        portions: "Portions",
        cookingInstructions: "Cooking Instructions",
        prepTime: "Prep Time (minutes)",
        cookTime: "Cook Time (minutes)",
        saveRecipe: "Save Recipe",
        updateRecipe: "Update Recipe",
        deleteConfirm: "Are you sure you want to delete this recipe?",
        noRecipes: "No recipes yet. Create your first recipe!",
        noIngredientsAdded: "No ingredients added yet. Click 'Add Ingredient' to start.",
        selectInventoryItem: "Select item...",
        timesUsed: "Used {{count}} times",
        mostUsed: "Most Used",
        avgCostPortion: "Avg Cost/Portion",
        totalRecipes: "Total Recipes",
        batchRecipes: "Batch Recipes",
        linkedRecipe: "Linked Recipe",
        selectRecipe: "Select a recipe...",
        noRecipe: "No recipe linked",
        autoInventory: "Auto inventory deduction"
      }
    }
  },
  ar: {
    translation: {
      // Landing Page
      landing: {
        // Navigation
        features: "المميزات",
        demo: "عرض توضيحي",
        posSystem: "نظام نقاط البيع",
        pricing: "الأسعار",
        getStarted: "ابدأ الآن",
        dashboard: "لوحة التحكم",
        
        // Hero Section
        badge: "نظام نقاط البيع السحابي للمطاعم",
        heroTitle1: "نظام نقاط بيع للمطاعم",
        heroTitle2: "مع تسويق ذكي مدمج",
        heroSubtitle: "أدِر مطعمك بنظام نقاط البيع السحابي الوحيد الذي يعالج البطاقات، ويبث إلى شاشة المطبخ، وينشئ محتوى إنستغرام وتيك توك تلقائيًا. ابدأ مجانًا إلى الأبد.",
        startFree: "ابدأ مجاناً الآن",
        goToDashboard: "اذهب إلى لوحة التحكم",
        watchDemo: "شاهد العرض",
        
        // Trust Badges
        noCredit: "بدون بطاقة ائتمان",
        freePlan: "خطة مجانية للأبد",
        freeImages: "10 صور بالذكاء الاصطناعي",
        
        // Feature Pills
        aiFeatures: "مميزات الذكاء الاصطناعي",
        aiContent: "إنشاء محتوى بالذكاء الاصطناعي",
        aiImage: "إنشاء صور بالذكاء الاصطناعي",
        videoReels: "فيديو وريلز",
        socialScheduling: "جدولة المنشورات",
        
        // Metrics
        restaurants: "مطعم",
        postsCreated: "منشور تم إنشاؤه",
        engagements: "تفاعل",
        successRate: "معدل النجاح",
        
        // Features Section
        featuresTitle: "قوى خارقة",
        featuresSubtitle: "لمطعمك",
        featuresDesc: "كل الأدوات التي تحتاجها للسيطرة على وسائل التواصل الاجتماعي",
        
        aiContentEngine: "محرك المحتوى بالذكاء الاصطناعي",
        aiContentDesc: "أنشئ التعليقات والوسوم والأوصاف على الفور",
        multiMediaCreator: "منشئ الوسائط المتعددة",
        multiMediaDesc: "ادمج الصور ومقاطع الفيديو في ريلز فيروسية",
        dailyInsights: "رؤى يومية بالذكاء الاصطناعي",
        dailyInsightsDesc: "أفكار محتوى جديدة كل يوم",
        aiImageGen: "إنشاء صور بالذكاء الاصطناعي",
        aiImageGenDesc: "أنشئ صور طعام من نصوص (DALL-E)",
        posSystemFeat: "نظام نقاط البيع",
        posSystemDesc: "نظام نقاط بيع كامل مع إدارة الطلبات والمخزون",
        hrManagement: "إدارة الموارد البشرية",
        hrManagementDesc: "إدارة الموظفين، كشوف المرتبات، المناوبات وتتبع المستندات",
        accounting: "المحاسبة",
        accountingDesc: "تتبع المبيعات، إدارة المصروفات والتقارير المالية",
        recipeManager: "مدير الوصفات",
        recipeManagerDesc: "اكتشف الوصفات، وإنشاءها بالذكاء الاصطناعي وتنظيم كتاب الطبخ",
        
        // Demo Section
        demoTitle: "شاهد الذكاء الاصطناعي",
        demoSubtitle: "يصنع السحر",
        demoDesc: "شاهد كيف يحول ذكاؤنا الاصطناعي صور الطعام البسيطة إلى محتوى فيروسي على وسائل التواصل الاجتماعي في ثوانٍ",
        
        // Success Stories
        successTitle: "نتائج حقيقية،",
        successSubtitle: "نمو حقيقي",
        
        // Pricing
        pricingBadge: "أسعار بسيطة",
        pricingTitle: "ابدأ مجاناً،",
        pricingSubtitle: "قم بالترقية في أي وقت",
        pricingDesc: "جرب FlavorFeed AI مع 5 إنشاءات صور بالذكاء الاصطناعي + 5 إنشاءات منشورات مجاناً. لا حاجة لبطاقة ائتمان. قم بالترقية عندما تكون جاهزاً.",
        pricesIn: "الأسعار معروضة بـ",
        monthly: "شهري",
        annual: "سنوي",
        saveAnnual: "وفّر حتى 20٪ مع الفوترة السنوية!",
        
        // Plans
        freePlanName: "مجاني",
        basicPlanName: "أساسي",
        proPlanName: "احترافي",
        enterprisePlanName: "المؤسسات",
        
        freeBadge: "ابدأ من هنا",
        basicBadge: "منشئو المحتوى",
        proBadge: "أفضل قيمة",
        enterpriseBadge: "مميز",
        
        perMonth: "/شهر",
        perYear: "/سنة",
        billedAnnually: "/شهر تدفع سنوياً",
        savePerYear: "وفّر",
        
        // CTA Buttons
        startFreeNow: "ابدأ مجاناً الآن",
        tryFree: "جربه مجاناً الآن",
        comparePlans: "قارن الخطط بالتفصيل",
        seeDetailedComparison: "عرض المقارنة التفصيلية",
        
        // Pricing Plan Features
        planFeatures: {
          // Free Plan
          aiImageGen: "إنشاءات صور بالذكاء الاصطناعي",
          aiProMakeover: "تحسين احترافي بالذكاء الاصطناعي",
          aiImageGeneration: "إنشاء صور بالذكاء الاصطناعي",
          uploadCamera: "رفع والتقاط الصور",
          aiCaptionsHashtags: "تعليقات ووسوم بالذكاء الاصطناعي",
          recipeManager: "الوصول إلى مدير الوصفات",
          basicFeatures: "الوصول للميزات الأساسية",
          
          // Basic Plan
          aiPreviewCredits: "رصيد معاينة الذكاء الاصطناعي/شهر",
          postCreations: "إنشاء منشورات/شهر",
          allFreeFeatures: "جميع ميزات الخطة المجانية",
          socialScheduling: "جدولة وسائل التواصل الاجتماعي",
          emailSupport: "دعم عبر البريد الإلكتروني",
          flavorFeedOnly: "FlavorFeed فقط (بدون نقاط البيع)",
          
          // Pro Plan
          everythingBasic: "كل ما في الخطة الأساسية",
          posStarter: "نظام نقاط البيع المبدئي مضمن",
          orderManagement: "إدارة الطلبات",
          menuManagementAI: "إدارة القائمة (ذكاء اصطناعي)",
          inventoryTracking: "تتبع المخزون",
          loyaltyNetwork: "شبكة الولاء (مجاناً لـ 6 أشهر)",
          crossRestaurant: "مكافآت عبر المطاعم",
          customerDatabase: "قاعدة بيانات العملاء",
          thenMonthly: "ثم 19 دولار/شهر",
          advancedAnalytics: "تحليلات متقدمة",
          prioritySupport: "دعم ذو أولوية",
          
          // Enterprise Plan
          unlimited: "غير محدود",
          aiGenerations: "إنشاءات الذكاء الاصطناعي",
          posts: "المنشورات",
          everythingPro: "كل ما في الخطة الاحترافية",
          posComplete: "نظام نقاط البيع الكامل",
          everythingStarter: "كل ما في النظام المبدئي",
          hrManagement: "إدارة الموارد البشرية",
          accountingModule: "وحدة المحاسبة",
          multiLocation: "دعم المواقع المتعددة",
          loyaltyForever: "شبكة الولاء (مجاناً للأبد)",
          multiLocationLoyalty: "ولاء متعدد المواقع",
          advancedCustomer: "تحليلات عملاء متقدمة",
          dedicatedManager: "مدير مخصص",
          advancedScheduling: "جدولة متقدمة",
          bulkRecurring: "منشورات جماعية ومتكررة",
          teamCollaboration: "تعاون الفريق",
          whiteLabel: "خيارات العلامة البيضاء",
          customIntegrations: "تكاملات مخصصة",
          dedicatedAccount: "مدير حساب مخصص",
          customTraining: "تدريب مخصص",
          sla: "ضمان وقت التشغيل 99.9%"
        },
        
        // Restaurant Management CTA Section
        restaurantMgmtBadge: "إدارة المطاعم",
        restaurantMgmtTitle: "هل تحتاج أكثر من وسائل التواصل الاجتماعي؟",
        restaurantMgmtDesc: "احصل على إدارة مطعم كاملة مع نقاط البيع، شبكة الولاء، الموارد البشرية والمحاسبة.",
        restaurantMgmtPOS: "نقاط البيع",
        restaurantMgmtLoyalty: "الولاء",
        restaurantMgmtHR: "الموارد البشرية",
        restaurantMgmtAccounting: "المحاسبة",
        explorePOS: "استكشف نظام نقاط البيع",
        
        // Final CTA Section - Go Viral
        readyToGo: "هل أنت مستعد",
        viral: "للانتشار الفيروسي؟",
        joinRestaurants: "انضم إلى أكثر من 500 مطعم ينشئون محتوى يحقق نتائج",
        startCreatingNow: "ابدأ الإنشاء الآن",
        
        // Footer
        footerCopyright: "FlavorFeed AI. منصة الذكاء الطهوي.",
        
        // FAQ
        faqTitle: "الأسئلة الشائعة",
        faqQ1: "ما الفرق بين جدولة المنشورات والجدولة المتقدمة؟",
        faqA1Part1: "جدولة المنشورات (احترافي - 139 دولار):",
        faqA1Part1Text: "جدولة أساسية حيث تختار التاريخ/الوقت للمنشورات الفردية. مثالية للمواقع الفردية التي تنشر 5-15 مرة أسبوعياً.",
        faqA1Part2: "الجدولة المتقدمة (المؤسسات - 379 دولار):",
        faqA1Part2Text: "تشمل الجدولة الجماعية، المنشورات المتكررة، التوقيت المدعوم بالذكاء الاصطناعي، التقويم البصري، تعاون الفريق، ومدير مخصص للتعامل مع صفحات وسائل التواصل الاجتماعي. مثالية لسلاسل المواقع المتعددة التي تنشر أكثر من 20 مرة أسبوعياً.",
        
        faqQ2: "أي خطة مناسبة لي؟",
        faqA2Text: "اختر الأساسية (99 دولار) إذا كنت تحتاج 50 معاينة ذكاء اصطناعي و20 منشور شهرياً. اختر الاحترافية (139 دولار) إذا كنت تريد 100 معاينة و50 منشور شهرياً، واحصل على نظام نقاط البيع المبدئي مجاناً لمدة 3 أشهر.",
        
        faqQ3: "أي خطة نقاط بيع يجب أن أختار؟",
        faqA3P1: "نقاط البيع المبدئي (49 دولار/شهر)",
        faqA3P1Text: "مثالي للمطاعم الصغيرة. يشمل إدارة الطلبات، المخزون الأساسي، وتقارير المبيعات. مجاني لمدة 3 أشهر مع الخطة الاحترافية!",
        faqA3P2: "نقاط البيع للأعمال (99 دولار/شهر)",
        faqA3P2Text: "الأفضل للمطاعم النامية. يضيف مخزون متقدم، تكامل المحاسبة، وتتبع المصروفات.",
        faqA3P3: "نقاط البيع للمؤسسات (199 دولار/شهر)",
        faqA3P3Text: "حل كامل مع إدارة الموارد البشرية، كشوف المرتبات، جدولة المناوبات، ودعم المواقع المتعددة.",
        
        faqQ4: "هل يمكنني الترقية أو التخفيض لاحقاً؟",
        faqA4Text: "نعم! يمكنك الترقية أو التخفيض في أي وقت. تصبح الترقيات سارية فوراً. التخفيضات تصبح سارية في نهاية دورة الفوترة الحالية. لا توجد التزامات طويلة الأمد.",
        
        faqQ5: "ماذا يحدث عندما أصل إلى حد الرصيد؟",
        faqA5Text: "ستتلقى إشعاراً عندما تقترب من حدك. يمكنك إما الانتظار لإعادة تعيين الرصيد في بداية دورة الفوترة التالية أو الترقية إلى خطة أعلى للحصول على المزيد من الرصيد فوراً.",
        
        faqQ6: "هل توجد خطة مجانية؟",
        faqA6Text: "نعم! تتضمن خطتنا المجانية 10 إنشاءات صور بالذكاء الاصطناعي والوصول إلى الميزات الأساسية بما في ذلك مدير الوصفات. لا حاجة لبطاقة ائتمان. مثالية لاختبار المنصة قبل الترقية.",
        
        // Footer
        privacyPolicy: "سياسة الخصوصية",
        termsOfService: "شروط الخدمة",
        contactUs: "اتصل بنا",
        copyright: "FlavorFeed AI. منصة الذكاء الطهوي."
      },

      // Main Dashboard
      mainDashboard: {
        free: "مجاني",
        ai: "ذكاء اصطناعي",
        posts: "المنشورات",
        admin: "المدير",
        plan: "الخطة",
        upgrade: "ترقية",
        portfolio: "المعرض",
        pos: "نقطة البيع",
        help: "المساعدة",
        logout: "تسجيل الخروج",
        create: "إنشاء",
        ideas: "الأفكار",
        myPosts: "المنشورات",
        platforms: "المنصات",
        recipes: "الوصفات",
        loyalty: "الولاء",
        subscription: "الاشتراك",
        settings: "الإعدادات",
        posSupport: "دعم نقطة البيع",
        dailyContentIdeas: "أفكار المحتوى اليومية",
        freshMarketingIdeas: "أفكار تسويقية جديدة يتم تحديثها يومياً",
        loadingDailyIdeas: "جاري تحميل الأفكار اليومية...",
        tips: "نصائح:",
        myPostsTitle: "منشوراتي",
        postsCount: "منشورات",
        atLimit: "⚠️ وصلت للحد الأقصى",
        nearLimit: "⚠️ قريب من الحد الأقصى",
        slotsRemaining: "خانات متبقية",
        tipArchive: "💡 نصيحة: يظهر في خلاصتك حتى 40 منشور. عند إنشاء المنشور رقم 41، سيتم أرشفة الأقدم تلقائياً للحفاظ على نضارة خلاصتك!",
        headsUpArchive: "⚠️ تنبيه: أنت قريب من حد الـ 40 منشور. إنشاء",
        morePost: "منشور إضافي",
        morePosts: "منشورات إضافية",
        willStartArchiving: "سيبدأ الأرشفة التلقائية للمحتوى الأقدم.",
        noPostsYet: "لا توجد منشورات بعد. أنشئ أول محتوى مدعوم بالذكاء الاصطناعي!",
        createYourFirst: "أنشئ أول"
      },
      
      // POS Landing Page
      posLanding: {
        // Navigation
        home: "الرئيسية",
        features: "المميزات",
        pricing: "الأسعار",
        tryFreeTrial: "جرّب النسخة التجريبية",
        
        // Hero
        badge: "إدارة المطاعم",
        heroTitle: "نظام إدارة",
        heroTitleHighlight: "مطعم",
        heroTitle2: "متكامل",
        heroSubtitle: "من الطلبات إلى المحاسبة - أدِر عملية مطعمك بالكامل في منصة واحدة قوية. نقاط البيع، الولاء، الموارد البشرية، والمزيد.",
        viewPricing: "عرض الأسعار",
        
        // Stats
        ordersDaily: "طلب معالج يومياً",
        uptime: "ضمان وقت التشغيل",
        restaurants: "مطعم",
        support: "الدعم",
        
        // Features
        featuresTitle: "كل ما تحتاجه",
        featuresTitleHighlight: "لإدارة مطعمك",
        featuresSubtitle: "مميزات قوية مصممة خصيصاً لعمليات المطاعم",
        
        orderManagement: "إدارة الطلبات",
        orderManagementDesc: "استلام طلبات سريع وسهل. إدارة الطاولات، شاشة المطبخ، وتتبع الطلبات في الوقت الفعلي.",
        menuManagement: "إدارة القائمة",
        menuManagementDesc: "إنشاء قائمة بالذكاء الاصطناعي مع الصور والأوصاف والأسعار. التحديث في ثوانٍ.",
        inventoryTracking: "تتبع المخزون",
        inventoryTrackingDesc: "لا تنفد المكونات أبداً. تنبيهات تلقائية، إدارة الموردين، وتتبع الهدر.",
        staffManagement: "إدارة الموظفين",
        staffManagementDesc: "جدولة المناوبات، تتبع الحضور، وإدارة الصلاحيات في مكان واحد.",
        paymentProcessing: "معالجة المدفوعات",
        paymentProcessingDesc: "قبول جميع طرق الدفع. تقسيم الفواتير، الإكراميات، وتأكيد الدفع الفوري.",
        salesReports: "تقارير المبيعات",
        salesReportsDesc: "رؤى فورية للمبيعات، الأصناف الشائعة، ساعات الذروة، واتجاهات الإيرادات.",
        
        // Loyalty
        loyaltyBadge: "شبكة الولاء",
        loyaltyTitle: "بناء ولاء",
        loyaltyTitleHighlight: "العملاء",
        loyaltySubtitle: "انضم إلى أكثر من 1,000 مطعم في شبكة FlavorFeed للولاء. يكسب العملاء النقاط ويستبدلونها عبر الشبكة بأكملها.",
        
        // Enterprise
        enterpriseBadge: "مميزات المؤسسات",
        enterpriseTitle: "قم بتوسيع نطاق",
        enterpriseTitleHighlight: "إمبراطورية مطعمك",
        enterpriseSubtitle: "مميزات متقدمة لسلاسل المطاعم المتنامية والعمليات متعددة المواقع",
        
        hrManagement: "إدارة الموارد البشرية",
        hrManagementDesc: "نظام موارد بشرية كامل لإدارة موظفي مطعمك بفعالية.",
        accountingModule: "وحدة المحاسبة",
        accountingModuleDesc: "نظام محاسبة كامل لتتبع الشؤون المالية وتعظيم الربحية.",
        
        // Pricing
        pricingTitle: "أي خطة تشمل",
        pricingTitleHighlight: "نقاط البيع؟",
        pricingSubtitle: "قارن ما هو مدرج في كل خطة",
        
        // CTA
        ctaTitle: "هل أنت مستعد لتحويل",
        ctaTitleHighlight: "مطعمك؟",
        ctaSubtitle: "انضم إلى أكثر من 1,000 مطعم يستخدمون بالفعل FlavorFeed POS. ابدأ تجربتك المجانية اليوم!",
        startFreeTrial: "ابدأ التجربة المجانية",
        needContent: "هل تحتاج إنشاء محتوى أيضاً؟",
        noCreditCard: "لا حاجة لبطاقة ائتمان • تجربة مجانية لمدة 14 يوماً • إلغاء في أي وقت",
        
        // Footer
        copyright: "FlavorFeed AI. حل إدارة مطاعم متكامل."
      },
      
      // Navigation & Sidebar
      nav: {
        orders: "الطلبات",
        menu: "القائمة",
        settings: "الإعدادات",
        dashboard: "لوحة التحكم",
        takeOrder: "طلب جديد",
        orderHistory: "سجل الطلبات",
        menuManagement: "إدارة القائمة",
        inventory: "المخزون",
        staff: "الموظفين",
        accounting: "المحاسبة",
        reports: "التقارير",
        loyalty: "برنامج الولاء",
        customers: "العملاء",
        tables: "الطاولات",
        support: "الدعم الفني",
        logout: "تسجيل الخروج",
        kitchenDisplay: "شاشة المطبخ",
        creditAccounts: "حسابات آجلة",
        menuEngineering: "هندسة القائمة",
        importData: "استيراد البيانات",
        receiptSettings: "إعدادات الفاتورة",
        aiChatbot: "الدردشة الذكية",
        systemSetup: "إعداد النظام",
        posSettings: "إعدادات نقطة البيع",
        printerSetup: "إعداد الطابعة"
      },

      // Kitchen Display
      kitchen: {
        title: "نظام شاشة المطبخ",
        newOrders: "طلبات جديدة",
        preparing: "قيد التحضير",
        ready: "جاهز",
        completed: "مكتمل",
        autoRefresh: "تحديث تلقائي",
        soundNotifications: "إشعارات صوتية",
        fullScreen: "ملء الشاشة",
        exitFullScreen: "إنهاء ملء الشاشة",
        refresh: "تحديث",
        startPreparing: "ابدأ التحضير",
        markReady: "جاهز",
        markCompleted: "مكتمل",
        printOrder: "طباعة الطلب",
        table: "الطاولة",
        orderNumber: "رقم الطلب",
        items: "الأصناف",
        notes: "ملاحظات",
        orderTime: "وقت الطلب",
        waitingTime: "وقت الانتظار",
        noOrders: "لا توجد طلبات"
      },
      
      // Dashboard
      dashboard: {
        title: "لوحة التحكم",
        welcome: "مرحباً",
        todayOverview: "نظرة عامة على اليوم",
        todayOrders: "طلبات اليوم",
        todayRevenue: "إيرادات اليوم",
        avgOrderValue: "متوسط قيمة الطلب",
        activeOrders: "الطلبات النشطة",
        completedOrders: "الطلبات المكتملة",
        pendingOrders: "الطلبات المعلقة",
        recentOrders: "الطلبات الأخيرة",
        topItems: "الأصناف الأكثر مبيعاً",
        quickStats: "إحصائيات سريعة",
        viewAll: "عرض الكل"
      },
      
      // Order Taking
      order: {
        selectItems: "اختر الأصناف",
        all: "الكل",
        orderType: "نوع الطلب",
        dineIn: "تناول في المطعم",
        takeaway: "سفري",
        delivery: "توصيل",
        tableNumber: "رقم الطاولة",
        cart: "السلة",
        cartEmpty: "السلة فارغة",
        subtotal: "المجموع الفرعي",
        tax: "الضريبة",
        vat: "ضريبة القيمة المضافة",
        total: "الإجمالي",
        placeOrder: "تقديم الطلب",
        processing: "جاري المعالجة...",
        todayOrders: "طلبات اليوم",
        todayRevenue: "إيرادات اليوم",
        activeOrders: "الطلبات النشطة",
        startPreparing: "ابدأ التحضير",
        markReady: "جاهز",
        complete: "مكتمل",
        addToCart: "أضف للسلة",
        removeFromCart: "إزالة من السلة",
        quantity: "الكمية",
        notes: "ملاحظات",
        specialInstructions: "تعليمات خاصة",
        customerName: "اسم العميل",
        customerPhone: "رقم الهاتف",
        paymentMethod: "طريقة الدفع",
        cash: "نقداً",
        card: "بطاقة",
        orderPlaced: "تم تقديم الطلب بنجاح",
        orderNumber: "رقم الطلب",
        printReceipt: "طباعة الفاتورة",
        unpaidOrders: "طلبات غير مدفوعة",
        phoneOrder: "طلب هاتفي"
      },
      
      // Order History
      orderHistory: {
        title: "سجل الطلبات",
        subtitle: "عرض وإدارة جميع الطلبات",
        orderNumber: "رقم الطلب",
        date: "التاريخ",
        time: "الوقت",
        customer: "العميل",
        items: "الأصناف",
        amount: "المبلغ",
        status: "الحالة",
        type: "النوع",
        table: "الطاولة",
        viewDetails: "عرض التفاصيل",
        filter: "تصفية",
        allOrders: "جميع الطلبات",
        today: "اليوم",
        thisWeek: "هذا الأسبوع",
        thisMonth: "هذا الشهر",
        statusPending: "معلق",
        statusPreparing: "قيد التحضير",
        statusReady: "جاهز",
        statusCompleted: "مكتمل",
        statusCancelled: "ملغي",
        noOrders: "لا توجد طلبات",
        totalOrders: "إجمالي الطلبات",
        totalRevenue: "إجمالي الإيرادات",
        dateRange: "نطاق التاريخ",
        searchPlaceholder: "رقم الطلب، اسم العميل، رقم الطاولة..."
      },
      
      // Menu Management
      menuMgmt: {
        title: "إدارة قائمة المطعم",
        subtitle: "إدارة أصناف القائمة",
        addMenuItem: "إضافة صنف",
        allItems: "جميع الأصناف",
        noItems: "لا توجد أصناف بعد",
        getStarted: "انقر على \"إضافة صنف\" للبدء!",
        available: "متاح",
        unavailable: "غير متاح",
        itemName: "اسم الصنف",
        category: "الفئة",
        price: "السعر",
        cost: "التكلفة",
        description: "الوصف",
        prepTime: "وقت التحضير",
        prepTimeMin: "وقت التحضير (دقيقة)",
        calories: "السعرات",
        caloriesKcal: "السعرات الحرارية (كيلو كالوري)",
        customizations: "الخيارات",
        cancel: "إلغاء",
        addItem: "إضافة",
        updateItem: "تحديث",
        required: "*",
        deleteConfirm: "هل أنت متأكد من حذف هذا الصنف؟",
        deleteSuccess: "تم حذف الصنف بنجاح!",
        addSuccess: "تمت إضافة الصنف بنجاح!",
        updateSuccess: "تم تحديث الصنف بنجاح!",
        selectCategory: "اختر الفئة",
        addNewCategory: "إضافة فئة جديدة",
        enterNewCategory: "أدخل اسم الفئة الجديدة",
        image: "الصورة",
        uploadImage: "رفع صورة",
        ingredients: "المكونات",
        allergens: "مسببات الحساسية",
        stock: "المخزون",
        inStock: "متوفر",
        outOfStock: "غير متوفر",
        lowStock: "مخزون منخفض",
        bilingualTip: "للقوائم ثنائية اللغة",
        showBothLanguages: "عرض اللغتين",
        saving: "جاري الحفظ..."
      },
      
      // Inventory Management
      inventory: {
        title: "إدارة المخزون",
        subtitle: "تتبع وإدارة مخزون المطعم",
        addItem: "إضافة صنف",
        itemName: "اسم الصنف",
        quantity: "الكمية",
        unit: "الوحدة",
        minStock: "الحد الأدنى",
        maxStock: "الحد الأقصى",
        currentStock: "المخزون الحالي",
        reorderLevel: "مستوى إعادة الطلب",
        supplier: "المورد",
        lastRestocked: "آخر تزويد",
        cost: "التكلفة",
        totalValue: "القيمة الإجمالية",
        category: "الفئة",
        lowStockItems: "أصناف منخفضة المخزون",
        outOfStockItems: "أصناف نفذت من المخزون",
        viewDetails: "عرض التفاصيل",
        updateStock: "تحديث المخزون",
        addStock: "إضافة للمخزون",
        removeStock: "إزالة من المخزون",
        stockHistory: "سجل المخزون",
        noItems: "لا توجد أصناف في المخزون"
      },
      
      // Staff Management
      staff: {
        title: "إدارة الموظفين",
        subtitle: "إدارة فريق العمل والصلاحيات",
        addEmployee: "إضافة موظف",
        employeeName: "اسم الموظف",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        role: "الدور الوظيفي",
        position: "المنصب",
        salary: "الراتب",
        hireDate: "تاريخ التعيين",
        status: "الحالة",
        active: "نشط",
        inactive: "غير نشط",
        permissions: "الصلاحيات",
        schedule: "الجدول الزمني",
        attendance: "الحضور",
        performance: "الأداء",
        documents: "المستندات",
        viewProfile: "عرض الملف الشخصي",
        editEmployee: "تعديل الموظف",
        deleteEmployee: "حذف الموظف",
        noEmployees: "لا يوجد موظفون",
        totalEmployees: "إجمالي الموظفين",
        onDuty: "في الخدمة",
        offDuty: "خارج الخدمة"
      },
      
      // Accounting
      accounting: {
        title: "لوحة المحاسبة",
        overview: "نظرة عامة",
        expenses: "المصروفات",
        purchaseOrders: "أوامر الشراء",
        bills: "الفواتير والمدفوعات",
        reports: "التقارير",
        suppliers: "الموردين",
        totalRevenue: "إجمالي الإيرادات",
        totalExpenses: "إجمالي المصروفات",
        netProfit: "صافي الربح",
        profitMargin: "هامش الربح",
        pendingBills: "فواتير معلقة",
        paidBills: "فواتير مدفوعة",
        overduePayments: "مدفوعات متأخرة",
        cashFlow: "التدفق النقدي",
        income: "الدخل",
        expense: "المصروف",
        balance: "الرصيد",
        addExpense: "إضافة مصروف",
        addPO: "إضافة أمر شراء",
        addBill: "إضافة فاتورة",
        addSupplier: "إضافة مورد",
        category: "الفئة",
        amount: "المبلغ",
        date: "التاريخ",
        description: "الوصف",
        status: "الحالة",
        paid: "مدفوع",
        pending: "معلق",
        overdue: "متأخر",
        dueDate: "تاريخ الاستحقاق",
        paymentMethod: "طريقة الدفع",
        supplier: "المورد",
        total: "الإجمالي",
        subtotal: "المجموع الفرعي",
        tax: "الضريبة",
        discount: "الخصم",
        save: "حفظ",
        cancel: "إلغاء",
        delete: "حذف",
        edit: "تعديل",
        view: "عرض",
        markAsPaid: "تحديد كمدفوع",
        download: "تنزيل",
        export: "تصدير",
        filter: "تصفية",
        search: "بحث",
        today: "اليوم",
        thisWeek: "هذا الأسبوع",
        thisMonth: "هذا الشهر",
        thisYear: "هذه السنة",
        custom: "مخصص",
        from: "من",
        to: "إلى",
        apply: "تطبيق",
        reset: "إعادة تعيين",
        // Legacy translations (keeping for compatibility)
        subtitle: "إدارة الحسابات والتقارير المالية",
        revenue: "الإيرادات",
        profit: "الربح",
        loss: "الخسارة",
        sales: "المبيعات",
        dailySales: "مبيعات اليوم",
        weeklySales: "مبيعات الأسبوع",
        monthlySales: "مبيعات الشهر",
        yearlySales: "مبيعات السنة",
        grossProfit: "إجمالي الربح",
        expenseCategory: "فئة المصروف",
        receipt: "الإيصال",
        invoice: "الفاتورة",
        viewInvoice: "عرض الفاتورة",
        downloadReport: "تحميل التقرير",
        printReport: "طباعة التقرير",
        financialSummary: "الملخص المالي",
        profitLossStatement: "قائمة الأرباح والخسائر",
        balanceSheet: "الميزانية العمومية"
      },
      
      // Reports
      reports: {
        title: "التقارير والتحليلات",
        subtitle: "تقارير مفصلة عن الأداء",
        salesReport: "تقرير المبيعات",
        inventoryReport: "تقرير المخزون",
        staffReport: "تقرير الموظفين",
        customerReport: "تقرير العملاء",
        financialReport: "التقرير المالي",
        dailyReport: "التقرير اليومي",
        weeklyReport: "التقرير الأسبوعي",
        monthlyReport: "التقرير الشهري",
        yearlyReport: "التقرير السنوي",
        customReport: "تقرير مخصص",
        generateReport: "إنشاء تقرير",
        exportPDF: "تصدير PDF",
        exportExcel: "تصدير Excel",
        dateRange: "نطاق التاريخ",
        from: "من",
        to: "إلى",
        apply: "تطبيق",
        topSellingItems: "الأصناف الأكثر مبيعاً",
        leastSellingItems: "الأصناف الأقل مبيعاً",
        peakHours: "ساعات الذروة",
        averageOrderValue: "متوسط قيمة الطلب",
        customerRetention: "معدل الاحتفاظ بالعملاء"
      },
      
      // Loyalty Program
      loyalty: {
        title: "برنامج الولاء",
        subtitle: "إدارة نقاط وعروض العملاء",
        points: "النقاط",
        rewards: "المكافآت",
        members: "الأعضاء",
        totalMembers: "إجمالي الأعضاء",
        activeMembers: "الأعضاء النشطون",
        pointsIssued: "النقاط الممنوحة",
        rewardsRedeemed: "المكافآت المستبدلة",
        memberName: "اسم العضو",
        memberID: "رقم العضوية",
        joinDate: "تاريخ الانضمام",
        totalPoints: "إجمالي النقاط",
        availablePoints: "النقاط المتاحة",
        redeemedPoints: "النقاط المستبدلة",
        tier: "المستوى",
        bronze: "برونزي",
        silver: "فضي",
        gold: "ذهبي",
        platinum: "بلاتيني",
        addPoints: "إضافة نقاط",
        redeemPoints: "استبدال نقاط",
        viewHistory: "عرض السجل",
        createReward: "إنشاء مكافأة",
        rewardName: "اسم المكافأة",
        pointsRequired: "النقاط المطلوبة",
        expiryDate: "تاريخ الانتهاء",
        terms: "الشروط والأحكام"
      },
      
      // Customer Management
      customers: {
        title: "إدارة العملاء",
        subtitle: "قاعدة بيانات العملاء",
        addCustomer: "إضافة عميل",
        customerName: "اسم العميل",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        address: "العنوان",
        birthday: "تاريخ الميلاد",
        notes: "ملاحظات",
        totalOrders: "إجمالي الطلبات",
        totalSpent: "إجمالي الإنفاق",
        lastVisit: "آخر زيارة",
        avgOrderValue: "متوسط قيمة الطلب",
        favoriteItems: "الأصناف المفضلة",
        loyaltyPoints: "نقاط الولاء",
        viewProfile: "عرض الملف الشخصي",
        editCustomer: "تعديل العميل",
        deleteCustomer: "حذف العميل",
        sendMessage: "إرسال رسالة",
        sendPromotion: "إرسال عرض",
        customerGroups: "مجموعات العملاء",
        vipCustomers: "عملاء VIP",
        regularCustomers: "عملاء منتظمون",
        newCustomers: "عملاء جدد"
      },
      
      // Table Management
      tables: {
        title: "إدارة الطاولات",
        subtitle: "حجز وإدارة الطاولات",
        tableNumber: "رقم الطاولة",
        capacity: "السعة",
        status: "الحالة",
        available: "متاحة",
        occupied: "مشغولة",
        reserved: "محجوزة",
        cleaning: "قيد التنظيف",
        section: "القسم",
        indoorSeating: "جلوس داخلي",
        outdoorSeating: "جلوس خارجي",
        privateRoom: "غرفة خاصة",
        currentOrder: "الطلب الحالي",
        orderTime: "وقت الطلب",
        waiter: "النادل",
        reservations: "الحجوزات",
        makeReservation: "إنشاء حجز",
        customerName: "اسم العميل",
        phone: "رقم الهاتف",
        date: "التاريخ",
        time: "الوقت",
        guests: "عدد الضيوف",
        specialRequests: "طلبات خاصة",
        confirmReservation: "تأكيد الحجز",
        cancelReservation: "إلغاء الحجز",
        qrCode: "رمز QR",
        generateQR: "إنشاء رمز QR",
        scanToOrder: "امسح للطلب"
      },
      
      // Settings
      settings: {
        title: "إعدادات المطعم",
        subtitle: "تكوين المنطقة والضرائب ومعلومات العمل",
        general: "عام",
        regionTax: "المنطقة والضريبة",
        country: "الدولة / المنطقة",
        selectCountry: "اختر دولة",
        taxRate: "نسبة الضريبة",
        currency: "العملة",
        businessInfo: "معلومات العمل",
        businessName: "اسم المطعم",
        vatNumber: "الرقم الضريبي",
        vatRecommended: "(موصى به)",
        vatWarning: "موصى به لفواتير هيئة الزكاة والضريبة. يجب أن يكون 15 رقماً، يبدأ وينتهي بـ 3.",
        businessAddress: "العنوان",
        phone: "رقم الهاتف",
        email: "البريد الإلكتروني",
        website: "الموقع الإلكتروني",
        language: "اللغة",
        selectLanguage: "اختر اللغة",
        timezone: "المنطقة الزمنية",
        dateFormat: "تنسيق التاريخ",
        timeFormat: "تنسيق الوقت",
        saveSettings: "حفظ الإعدادات",
        saving: "جاري الحفظ...",
        reset: "إعادة تعيين",
        settingsSaved: "تم حفظ الإعدادات بنجاح!",
        changesApplied: "تم تطبيق التغييرات.",
        notifications: "الإشعارات",
        emailNotifications: "إشعارات البريد الإلكتروني",
        smsNotifications: "إشعارات الرسائل النصية",
        pushNotifications: "إشعارات الدفع",
        security: "الأمان",
        changePassword: "تغيير كلمة المرور",
        twoFactorAuth: "المصادقة الثنائية",
        loginHistory: "سجل تسجيل الدخول",
        integrations: "التكاملات",
        paymentGateways: "بوابات الدفع",
        deliveryPartners: "شركاء التوصيل",
        accountingTools: "أدوات المحاسبة"
      },
      
      // Support
      support: {
        title: "الدعم الفني",
        subtitle: "المساعدة والدعم",
        helpCenter: "مركز المساعدة",
        documentation: "الوثائق",
        videoTutorials: "دروس الفيديو",
        faq: "الأسئلة الشائعة",
        contactSupport: "اتصل بالدعم",
        reportIssue: "الإبلاغ عن مشكلة",
        featureRequest: "طلب ميزة",
        issueType: "نوع المشكلة",
        priority: "الأولوية",
        low: "منخفضة",
        medium: "متوسطة",
        high: "عالية",
        urgent: "عاجلة",
        subject: "الموضوع",
        message: "الرسالة",
        attachments: "المرفقات",
        submit: "إرسال",
        ticketNumber: "رقم التذكرة",
        status: "الحالة",
        open: "مفتوحة",
        inProgress: "قيد المعالجة",
        resolved: "محلولة",
        closed: "مغلقة",
        viewTicket: "عرض التذكرة",
        myTickets: "تذاكري"
      },
      
      // Cash Drawer Management
      cashDrawer: {
        title: "إدارة الصندوق النقدي",
        manageCashFlow: "إدارة التدفق النقدي وعمليات الورديات",
        noActiveSession: "لا توجد وردية مفتوحة",
        openShiftPrompt: "ابدأ وردية جديدة لتتبع التدفق النقدي",
        openShift: "فتح وردية",
        closeShift: "إغلاق الوردية",
        shiftOpen: "الوردية مفتوحة",
        cashier: "أمين الصندوق",
        cashierName: "اسم أمين الصندوق",
        shiftStart: "بداية الوردية",
        shiftDuration: "المدة",
        minutesAgo: "دقيقة مضت",
        openingBalance: "الرصيد الافتتاحي",
        closingBalance: "الرصيد الختامي",
        expectedCash: "النقد المتوقع في الصندوق",
        expectedCashDesc: "بناءً على الرصيد الافتتاحي + المبيعات النقدية + إضافات - سحوبات",
        actualCashCount: "عدد النقد الفعلي",
        totalOrders: "إجمالي الطلبات",
        cashSales: "مبيعات نقدية",
        cardSales: "مبيعات بالبطاقة",
        cashIn: "إضافة نقد",
        cashOut: "سحب نقد",
        addCash: "إضافة نقد",
        removeCash: "سحب نقد",
        amount: "المبلغ",
        reason: "السبب",
        notes: "ملاحظات",
        closingNotes: "ملاحظات الإغلاق",
        startShift: "بدء الوردية",
        autoCloseHours: "إغلاق تلقائي بعد",
        autoCloseDesc: "سيتم إغلاق الوردية تلقائياً بعد هذا العدد من الساعات",
        lastClosing: "مقترح من آخر وردية",
        variance: "الفرق",
        varianceWarning: "عدد النقد لا يطابق المبلغ المتوقع. مطلوب موافقة المدير.",
        overrideAndClose: "تجاوز وإغلاق الوردية",
        countDenominations: "العد حسب الفئات",
        hideDenominations: "إخفاء عداد الفئات",
        denominationCount: "عد النقد حسب الفئة",
        recentTransactions: "العمليات النقدية الأخيرة"
      },

      // Recipe Management
      recipes: {
        title: "إدارة الوصفات",
        subtitle: "إنشاء وصفات دفعات مع التحكم التلقائي بالمخزون",
        createRecipe: "إنشاء وصفة",
        editRecipe: "تعديل الوصفة",
        deleteRecipe: "حذف الوصفة",
        duplicateRecipe: "نسخ الوصفة",
        recipeName: "اسم الوصفة",
        recipeType: "نوع الوصفة",
        batchProduction: "إنتاج دفعات",
        singleServing: "حصة واحدة",
        description: "الوصف",
        batchDetails: "تفاصيل الدفعة والحصص",
        batchSize: "حجم الدفعة",
        portionSize: "حجم الحصة",
        totalPortions: "إجمالي الحصص",
        ingredients: "المكونات",
        addIngredient: "إضافة مكون",
        inventoryItem: "عنصر المخزون",
        quantity: "الكمية",
        cost: "التكلفة",
        costSummary: "ملخص التكلفة",
        totalBatchCost: "تكلفة الدفعة الإجمالية",
        costPerPortion: "تكلفة الحصة",
        portions: "الحصص",
        cookingInstructions: "تعليمات الطهي",
        prepTime: "وقت التحضير (دقائق)",
        cookTime: "وقت الطهي (دقائق)",
        saveRecipe: "حفظ الوصفة",
        updateRecipe: "تحديث الوصفة",
        deleteConfirm: "هل أنت متأكد من حذف هذه الوصفة؟",
        noRecipes: "لا توجد وصفات بعد. أنشئ وصفتك الأولى!",
        noIngredientsAdded: "لم تتم إضافة مكونات بعد. انقر على 'إضافة مكون' للبدء.",
        selectInventoryItem: "اختر عنصر...",
        timesUsed: "استخدمت {{count}} مرة",
        mostUsed: "الأكثر استخداماً",
        avgCostPortion: "متوسط تكلفة الحصة",
        totalRecipes: "إجمالي الوصفات",
        batchRecipes: "وصفات الدفعات",
        linkedRecipe: "الوصفة المرتبطة",
        selectRecipe: "اختر وصفة...",
        noRecipe: "لا توجد وصفة مرتبطة",
        autoInventory: "خصم تلقائي من المخزون"
      },

      // Sidebar Navigation
      sidebar: {
        analyticsReports: "التحليلات والتقارير",
        dashboardOverview: "نظرة عامة على لوحة التحكم",
        aiAnalytics: "تحليلات الذكاء الاصطناعي",
        reports: "التقارير",
        menuInventory: "القائمة والمخزون",
        menuManagement: "إدارة القائمة",
        inventory: "المخزون",
        recipeManagement: "إدارة الوصفات",
        importData: "استيراد البيانات",
        procurementAccounts: "المشتريات والحسابات",
        accounting: "المحاسبة",
        creditAccounts: "الحسابات الآجلة",
        cashDrawer: "صندوق النقد",
        enterprise: "المؤسسة",
        multiBranch: "الفروع المتعددة",
        loyaltyProgram: "برنامج الولاء",
        staffHR: "الموظفين والموارد البشرية",
        employeeManagement: "إدارة الموظفين",
        hrDashboard: "لوحة الموارد البشرية",
        systemSetup: "إعداد النظام",
        posSettings: "إعدادات نقطة البيع",
        openPOSTerminal: "فتح نقطة البيع",
        adminDashboard: "لوحة التحكم"
      },

      // POS Terminal
      posTerminal: {
        takeOrder: "طلب جديد",
        kitchenDisplay: "شاشة المطبخ",
        tables: "الطاولات",
        orderHistory: "سجل الطلبات",
        cashDrawer: "صندوق النقد"
      },

      // Common
      common: {
        save: "حفظ",
        close: "إغلاق",
        edit: "تعديل",
        delete: "حذف",
        search: "بحث",
        filter: "تصفية",
        sort: "ترتيب",
        loading: "جاري التحميل...",
        min: "د",
        new: "جديد",
        pos: "نقطة البيع",
        quickAccess: "وصول سريع",
        each: "للواحد",
        tapToActivate: "اضغط للتفعيل",
        hour: "ساعة",
        day: "يوم",
        week: "أسبوع",
        month: "شهر",
        year: "سنة",
        yes: "نعم",
        no: "لا",
        confirm: "تأكيد",
        cancel: "إلغاء",
        back: "رجوع",
        next: "التالي",
        previous: "السابق",
        finish: "إنهاء",
        view: "عرض",
        download: "تحميل",
        upload: "رفع",
        print: "طباعة",
        export: "تصدير",
        import: "استيراد",
        refresh: "تحديث",
        select: "اختر",
        selectAll: "اختر الكل",
        clear: "مسح",
        apply: "تطبيق",
        reset: "إعادة تعيين",
        add: "إضافة",
        remove: "إزالة",
        update: "تحديث",
        create: "إنشاء",
        submit: "إرسال",
        send: "إرسال",
        required: "مطلوب",
        optional: "اختياري",
        success: "نجح",
        error: "خطأ",
        warning: "تحذير",
        info: "معلومات",
        today: "اليوم",
        yesterday: "أمس",
        tomorrow: "غداً",
        thisWeek: "هذا الأسبوع",
        thisMonth: "هذا الشهر",
        thisYear: "هذه السنة",
        all: "الكل",
        none: "لا شيء",
        active: "نشط",
        inactive: "غير نشط",
        enabled: "مفعّل",
        disabled: "معطّل",
        available: "متاح",
        unavailable: "غير متاح",
        online: "متصل",
        offline: "غير متصل",
        total: "الإجمالي",
        subtotal: "المجموع الفرعي",
        discount: "الخصم",
        tax: "الضريبة",
        amount: "المبلغ",
        quantity: "الكمية",
        price: "السعر",
        cost: "التكلفة",
        profit: "الربح",
        from: "من",
        to: "إلى",
        date: "التاريخ",
        time: "الوقت",
        name: "الاسم",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        address: "العنوان",
        description: "الوصف",
        notes: "ملاحظات",
        status: "الحالة",
        type: "النوع",
        category: "الفئة"
      },
      
      // Categories
      categories: {
        "Pizza": "بيتزا",
        "Burgers": "برجر",
        "Indian": "هندي",
        "Salads": "سلطات",
        "Thai": "تايلندي",
        "Italian": "إيطالي",
        "Drinks": "مشروبات",
        "Desserts": "حلويات",
        "Appetizers": "مقبلات",
        "Main Course": "الطبق الرئيسي",
        "Sides": "أطباق جانبية",
        "Beverages": "مشروبات",
        "Coffee": "قهوة",
        "Tea": "شاي",
        "Juice": "عصير"
      }
    }
  },
  es: {
    translation: {
      // Navigation
      nav: {
        orders: "Pedidos",
        menu: "Menú",
        settings: "Configuración",
        dashboard: "Panel de Control",
        takeOrder: "Tomar Pedido",
        orderHistory: "Historial de Pedidos",
        menuManagement: "Gestión de Menú",
        inventory: "Inventario",
        staff: "Personal",
        accounting: "Contabilidad",
        reports: "Informes",
        loyalty: "Fidelización",
        customers: "Clientes",
        tables: "Mesas",
        support: "Soporte",
        logout: "Cerrar Sesión",
        kitchenDisplay: "Pantalla de Cocina",
        creditAccounts: "Cuentas de Crédito",
        menuEngineering: "Ingeniería de Menú",
        importData: "Importar Datos",
        receiptSettings: "Configuración de Recibos",
        aiChatbot: "Chatbot IA",
        systemSetup: "Configuración del Sistema",
        posSettings: "Configuración POS",
        printerSetup: "Configuración de Impresora"
      },

      // Sidebar Navigation
      sidebar: {
        analyticsReports: "Análisis e Informes",
        dashboardOverview: "Resumen del Panel",
        aiAnalytics: "Análisis IA",
        reports: "Informes",
        menuInventory: "Menú e Inventario",
        menuManagement: "Gestión de Menú",
        inventory: "Inventario",
        recipeManagement: "Gestión de Recetas",
        importData: "Importar Datos",
        procurementAccounts: "Compras y Cuentas",
        accounting: "Contabilidad",
        creditAccounts: "Cuentas de Crédito",
        cashDrawer: "Caja Registradora",
        transactionHistory: "Historial de Transacciones",
        enterprise: "Empresa",
        multiBranch: "Multi-Sucursal",
        loyaltyProgram: "Programa de Fidelización",
        staffHR: "Personal y RRHH",
        employeeManagement: "Gestión de Empleados",
        hrDashboard: "Panel de RRHH",
        systemSetup: "Configuración del Sistema",
        posSettings: "Configuración POS",
        openPOSTerminal: "Abrir Terminal POS",
        adminDashboard: "Panel de Administración"
      },

      // Kitchen Display
      kitchen: {
        title: "Pantalla de Cocina",
        newOrders: "Nuevos Pedidos",
        preparing: "Preparando",
        ready: "Listo",
        completed: "Completado",
        autoRefresh: "Auto Actualizar",
        soundNotifications: "Notificaciones de Sonido",
        fullScreen: "Pantalla Completa",
        exitFullScreen: "Salir de Pantalla Completa",
        refresh: "Actualizar",
        startPreparing: "Comenzar a Preparar",
        markReady: "Marcar como Listo",
        markCompleted: "Marcar como Completado",
        printOrder: "Imprimir Pedido",
        table: "Mesa",
        orderNumber: "Pedido #",
        items: "Artículos",
        notes: "Notas",
        orderTime: "Hora del Pedido",
        waitingTime: "En Espera",
        noOrders: "Sin pedidos"
      },

      // Order Taking
      order: {
        selectItems: "Seleccionar Artículos",
        all: "Todos",
        orderType: "Tipo de Pedido",
        dineIn: "Para Comer Aquí",
        takeaway: "Para Llevar",
        delivery: "Entrega a Domicilio",
        tableNumber: "Número de Mesa",
        cart: "Carrito",
        cartEmpty: "El carrito está vacío",
        subtotal: "Subtotal",
        tax: "Impuesto",
        vat: "IVA",
        total: "Total",
        placeOrder: "Realizar Pedido",
        processing: "Procesando...",
        todayOrders: "Pedidos de Hoy",
        todayRevenue: "Ingresos de Hoy",
        activeOrders: "Pedidos Activos",
        startPreparing: "Comenzar a Preparar",
        markReady: "Marcar como Listo",
        complete: "Completar"
      },

      // Menu Management
      menuMgmt: {
        title: "Gestión de Menú POS",
        subtitle: "Administre los artículos del menú de su restaurante",
        addMenuItem: "Agregar Artículo",
        allItems: "Todos los Artículos",
        noItems: "Aún no hay artículos en el menú",
        getStarted: "¡Haga clic en \"Agregar Artículo\" para comenzar!",
        available: "Disponible",
        unavailable: "No Disponible",
        itemName: "Nombre del Artículo",
        category: "Categoría",
        price: "Precio",
        cost: "Costo",
        description: "Descripción",
        prepTime: "Tiempo de Preparación",
        prepTimeMin: "Tiempo de Preparación (min)",
        calories: "Calorías",
        caloriesKcal: "Calorías (kcal)",
        customizations: "Personalizaciones",
        cancel: "Cancelar",
        addItem: "Agregar Artículo",
        required: "*",
        deleteConfirm: "¿Está seguro de que desea eliminar este artículo?",
        deleteSuccess: "¡Artículo eliminado exitosamente!",
        addSuccess: "¡Artículo del menú agregado exitosamente!",
        selectCategory: "Seleccionar categoría",
        addNewCategory: "Agregar Nueva Categoría",
        enterNewCategory: "Ingrese el nombre de la nueva categoría"
      },

      // Settings
      settings: {
        title: "Configuración del Restaurante",
        subtitle: "Configure su región, impuestos e información comercial",
        regionTax: "Región e Impuestos",
        country: "País / Región",
        selectCountry: "Seleccionar un país",
        taxRate: "Tasa de Impuesto",
        currency: "Moneda",
        businessInfo: "Información del Negocio",
        businessName: "Nombre del Negocio",
        vatNumber: "Número de Registro Fiscal / IVA",
        vatRecommended: "(Recomendado)",
        vatWarning: "Recomendado para facturas conformes con ZATCA. Debe tener 15 dígitos, empezar y terminar con 3.",
        businessAddress: "Dirección del Negocio",
        phone: "Teléfono",
        email: "Correo Electrónico",
        language: "Idioma",
        selectLanguage: "Seleccionar idioma",
        saveSettings: "Guardar Configuración",
        saving: "Guardando...",
        reset: "Restablecer",
        settingsSaved: "¡Configuración Guardada Exitosamente!",
        changesApplied: "Sus cambios han sido aplicados."
      },

      // Accounting
      accounting: {
        title: "Panel de Contabilidad",
        overview: "Resumen",
        expenses: "Gastos",
        purchaseOrders: "Órdenes de Compra",
        bills: "Facturas y Pagos",
        reports: "Informes",
        suppliers: "Proveedores",
        totalRevenue: "Ingresos Totales",
        totalExpenses: "Gastos Totales",
        netProfit: "Ganancia Neta",
        profitMargin: "Margen de Ganancia",
        pendingBills: "Facturas Pendientes",
        paidBills: "Facturas Pagadas",
        overduePayments: "Pagos Vencidos",
        cashFlow: "Flujo de Caja",
        income: "Ingresos",
        expense: "Gasto",
        balance: "Saldo",
        addExpense: "Agregar Gasto",
        addPO: "Agregar Orden de Compra",
        addBill: "Agregar Factura",
        addSupplier: "Agregar Proveedor",
        category: "Categoría",
        amount: "Monto",
        date: "Fecha",
        description: "Descripción",
        status: "Estado",
        paid: "Pagado",
        pending: "Pendiente",
        overdue: "Vencido",
        dueDate: "Fecha de Vencimiento",
        paymentMethod: "Método de Pago",
        supplier: "Proveedor",
        total: "Total",
        subtotal: "Subtotal",
        tax: "Impuesto",
        discount: "Descuento",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        edit: "Editar",
        view: "Ver",
        markAsPaid: "Marcar como Pagado",
        download: "Descargar",
        export: "Exportar",
        filter: "Filtrar",
        search: "Buscar",
        today: "Hoy",
        thisWeek: "Esta Semana",
        thisMonth: "Este Mes",
        thisYear: "Este Año",
        custom: "Personalizado",
        from: "Desde",
        to: "Hasta",
        apply: "Aplicar",
        reset: "Restablecer"
      },

      // POS Terminal
      posTerminal: {
        takeOrder: "Tomar Pedido",
        kitchenDisplay: "Pantalla de Cocina",
        tables: "Mesas",
        orderHistory: "Historial de Pedidos",
        cashDrawer: "Caja Registradora"
      },

      // Cash Drawer Management
      cashDrawer: {
        title: "Gestión de Caja Registradora",
        manageCashFlow: "Administre el flujo de efectivo y las operaciones de turno",
        noActiveSession: "Sin Sesión de Caja Activa",
        openShiftPrompt: "Inicie un nuevo turno para comenzar a rastrear el flujo de efectivo",
        openShift: "Abrir Turno",
        closeShift: "Cerrar Turno",
        shiftOpen: "Turno Abierto",
        cashier: "Cajero",
        cashierName: "Nombre del Cajero",
        shiftStart: "Turno Iniciado",
        shiftDuration: "Duración",
        minutesAgo: "minutos atrás",
        openingBalance: "Saldo Inicial",
        closingBalance: "Saldo Final",
        expectedCash: "Efectivo Esperado en Caja",
        expectedCashDesc: "Basado en saldo inicial + ventas en efectivo + entradas - salidas",
        actualCashCount: "Conteo Real de Efectivo",
        totalOrders: "Total de Pedidos",
        cashSales: "Ventas en Efectivo",
        cardSales: "Ventas con Tarjeta",
        cashIn: "Entrada de Efectivo",
        cashOut: "Salida de Efectivo",
        addCash: "Agregar Efectivo",
        removeCash: "Retirar Efectivo",
        amount: "Monto",
        reason: "Razón",
        notes: "Notas",
        closingNotes: "Notas de Cierre",
        startShift: "Iniciar Turno",
        autoCloseHours: "Auto-Cerrar Después de",
        autoCloseDesc: "El turno se cerrará automáticamente después de estas horas",
        lastClosing: "Sugerido del último turno",
        variance: "Diferencia",
        varianceWarning: "El conteo de efectivo no coincide con el monto esperado. Se requiere aprobación del gerente.",
        overrideAndClose: "Aprobar y Cerrar Turno",
        countDenominations: "Contar por Denominaciones",
        hideDenominations: "Ocultar Contador de Denominaciones",
        denominationCount: "Contar Efectivo por Denominación",
        recentTransactions: "Transacciones Recientes de Efectivo"
      },

      // Recipe Management
      recipes: {
        title: "Gestión de Recetas",
        subtitle: "Cree recetas por lotes con control automático de inventario",
        createRecipe: "Crear Receta",
        editRecipe: "Editar Receta",
        deleteRecipe: "Eliminar Receta",
        duplicateRecipe: "Duplicar Receta",
        recipeName: "Nombre de la Receta",
        recipeType: "Tipo de Receta",
        batchProduction: "Producción por Lotes",
        singleServing: "Porción Individual",
        description: "Descripción",
        batchDetails: "Detalles de Lote y Porción",
        batchSize: "Tamaño del Lote",
        portionSize: "Tamaño de la Porción",
        totalPortions: "Porciones Totales",
        ingredients: "Ingredientes",
        addIngredient: "Agregar Ingrediente",
        inventoryItem: "Artículo del Inventario",
        quantity: "Cantidad",
        cost: "Costo",
        costSummary: "Resumen de Costos",
        totalBatchCost: "Costo Total del Lote",
        costPerPortion: "Costo por Porción",
        portions: "Porciones",
        cookingInstructions: "Instrucciones de Cocina",
        prepTime: "Tiempo de Preparación (minutos)",
        cookTime: "Tiempo de Cocción (minutos)",
        saveRecipe: "Guardar Receta",
        updateRecipe: "Actualizar Receta",
        deleteConfirm: "¿Está seguro de que desea eliminar esta receta?",
        noRecipes: "Aún no hay recetas. ¡Cree su primera receta!",
        noIngredientsAdded: "Aún no se han agregado ingredientes. Haga clic en 'Agregar Ingrediente' para comenzar.",
        selectInventoryItem: "Seleccionar artículo...",
        timesUsed: "Usado {{count}} veces",
        mostUsed: "Más Usado",
        avgCostPortion: "Costo Promedio/Porción",
        totalRecipes: "Total de Recetas",
        batchRecipes: "Recetas por Lotes",
        linkedRecipe: "Receta Vinculada",
        selectRecipe: "Seleccionar una receta...",
        noRecipe: "Sin receta vinculada",
        autoInventory: "Deducción automática de inventario"
      },

      // Common
      common: {
        save: "Guardar",
        close: "Cerrar",
        edit: "Editar",
        delete: "Eliminar",
        search: "Buscar",
        loading: "Cargando...",
        min: "min",
        new: "NUEVO"
      },

      // Staff
      staff: {
        title: "Gestión de Personal",
        subtitle: "Administre el equipo y los permisos"
      },

      // Reports
      reports: {
        title: "Informes",
        subtitle: "Análisis y perspectivas"
      },

      // Tables
      tables: {
        title: "Mesas",
        subtitle: "Gestión de mesas"
      },

      // Customers
      customers: {
        title: "Clientes",
        subtitle: "Gestión de clientes",
        customerGroups: "Grupos de Clientes"
      },

      // Loyalty
      loyalty: {
        title: "Red de Fidelización",
        subtitle: "Programa de fidelización"
      },

      // Categories
      categories: {
        "Pizza": "Pizza",
        "Burgers": "Hamburguesas",
        "Indian": "India",
        "Salads": "Ensaladas",
        "Thai": "Tailandesa",
        "Italian": "Italiana",
        "Drinks": "Bebidas"
      }
    }
  }
};

// Get initial language from localStorage or default to 'en'
let savedLanguage = 'en';
try {
  savedLanguage = localStorage.getItem('language') || 'en';
} catch (e) {
  console.warn('Could not access localStorage for language preference');
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, // Use saved language or default
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    // React 19 compatibility settings
    react: {
      useSuspense: false,  // Disable Suspense for React 19 compatibility
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'span'],
    },
    // Ensure t() always returns a string
    returnObjects: false,
    returnEmptyString: false,
    returnNull: false,
    // Return key if translation is missing
    saveMissing: false,
    missingKeyHandler: (lng, ns, key) => {
      console.warn(`Missing translation: ${key}`);
    }
  });

// CRITICAL: Monkey-patch the t function to ensure it ALWAYS returns a string
// This fixes React Error #31 in production builds
const originalT = i18n.t.bind(i18n);
i18n.t = function safeT(key, options) {
  try {
    const result = originalT(key, options);
    if (typeof result === 'string') {
      return result;
    }
    // If result is not a string, log and return fallback
    console.warn(`[i18n] Non-string result for key "${key}":`, typeof result);
    if (typeof options === 'string') {
      return options;
    }
    if (options?.defaultValue && typeof options.defaultValue === 'string') {
      return options.defaultValue;
    }
    return String(key).split('.').pop() || String(key);
  } catch (e) {
    console.error(`[i18n] Error translating "${key}":`, e);
    return String(key).split('.').pop() || String(key);
  }
};

export default i18n;
